import { LoginAPI, LogOutAPI } from "../api/LoginAPI";
import Swal from 'sweetalert2'; // Import SweetAlert2

export const logIn = (formData, navigate) => async (dispatch) => {
    dispatch({ type: "AUTH_START" });
    try {
        const { data } = await LoginAPI(formData);
        if(data.status === true){
            dispatch({ type: "AUTH_SUCCESS", data: data });
            navigate("../dashboard", { replace: true });
        }else{
            dispatch({ type: "AUTH_FAIL" });
            Swal.fire({
                icon: 'error',
                title: 'Login Failed',
                text: data.message,
            });
        }
    } catch (error) {
        dispatch({ type: "AUTH_FAIL" });
        Swal.fire({
            icon: 'error',
            title: 'Login Failed',
            text: 'Something went wrong please try again.',
        });
    }
}

export const logout = (token) => async (dispatch) => {
    const { data } = await LogOutAPI(token);
    if(data.status){
        dispatch({ type: "LOG_OUT" })
    }else{
        Swal.fire({
            icon: 'error',
            title: 'Logout Failed',
            text: 'Something went wrong please try again.',
        });
    }
}